import React, { Component } from "react";
import { connect } from "react-redux";

import { getLoggedInUser } from "../helpers/authUtils";
import CrudBar from "../gb-components/CrudBar";
import { Row, Col } from "reactstrap";
import CardHome from '../gb-components/CardHome';
import EspecialidadesDropdown from "../gb-components/GbDropdown";
import PreLoaderWidget from "../components/Loader";
import { getEspecialidadeNew } from "../Libs/especialidade";
import { getPacientesWithStatus } from "../Libs/paciente";
import { getUser } from "../Libs/User";
import ModalComponent from "../components/Modal";
import Paciente from '../Views/Paciente/historico'

class ConsultasRealizadas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: getLoggedInUser(),
            loading: true,
            especialidadeSelecionada: '',
            especialidades: [],
            finalizado: null,
            finalizadoList: null,
            aguardando: null,
            aguardandoList: null,
            agCirurgia: null,
            agCirurgiaList: null,
            pedente: null,
            pedenteList: null,
            posOperatorio: null,
            posOperatorioList: null,
            agendado: null,
            agendadoList: null,
            ambulatorial: null,
            ambulatorialList: null,
            openModal: false,
            listPacienteFiltredModal: [],
        };
    }

    async componentDidMount() {
        this.setState({ loading: true })
        const esps = await getEspecialidadeNew()
        const especialidades = esps.map((item, index) => {
            return item.especialidade.Nome;
        });

        await this.carregar()

        this.setState({
            especialidades,
            loading: false
        })
    }
    async carregar() {
        await getPacientesWithStatus()
            .then(async (paciente) => {
                var finalizado = [];
                var aguardando = [];
                var agCirurgia = [];
                var pedente = [];
                var posOperatorio = [];
                var agendado = [];
                var ambulatorial = [];

                paciente.forEach(item => {
                    if (
                        ((getLoggedInUser().permissao.toString() == "0" || getLoggedInUser().permissao.toString() == "1") && (!item.paciente.responsavel || item.paciente.responsavel.id === getLoggedInUser().cpf))
                        ||
                        (getLoggedInUser().permissao.toString() != "0" && getLoggedInUser().permissao.toString() != "1")) {
                        switch (item.paciente.status) {
                            case "Finalizado":
                                finalizado.push(item);
                                break;
                            case "Aguardando Análise": {
                                // console.log("AGUARDANDO", item.paciente);
                                if (!item.paciente.resposnavel || item.paciente.resposnavel.id === getLoggedInUser().cpf) {
                                    aguardando.push(item);
                                }
                                break;
                            }
                            case "Aguardando Cirurgia":
                                agCirurgia.push(item);
                                break;
                            case "Pendências":
                                pedente.push(item);
                                break;
                            case "Acompanhamento Pós Operatório":
                                posOperatorio.push(item);
                                break;
                            case "Acompanhamento Ambulatorial":
                                ambulatorial.push(item);
                                break;
                            case "Agendado":
                                agendado.push(item);
                                break;

                        }
                    }
                });

                this.setState({
                    finalizado,
                    finalizadoList: finalizado,
                    aguardando,
                    aguardandoList: aguardando,
                    agCirurgia,
                    agCirurgiaList: agCirurgia,
                    pedente,
                    pedenteList: pedente,
                    posOperatorio,
                    posOperatorioList: posOperatorio,
                    agendado,
                    agendadoList: agendado,
                    ambulatorial,
                    ambulatorialList: ambulatorial
                }, () => {
                    if (this.state.especialidadeSelecionada) {
                        this.changeTab(this.state.especialidadeSelecionada);
                    }
                });


            })
            .catch(erro => console.log(erro));
    }

    changeTab = async (tab) => {
        this.setState({ especialidadeSelecionada: tab });
        this.setState({ loading: true });

        const canBe = (x) => {
            return (tab !== '' && (x.paciente.especialidades && x.paciente.especialidades.indexOf(tab) >= 0) ||
                (tab === 'CARDIOLOGIA' && x.paciente.samu && x.paciente.samu !== '')) || tab === '';
        }

        this.setState({
            finalizado: this.state.finalizadoList.filter(x => canBe(x)),
            aguardando: this.state.aguardandoList.filter(x => canBe(x)),
            agCirurgia: this.state.agCirurgiaList.filter(x => canBe(x)),
            pedente: this.state.pedenteList.filter(x => canBe(x)),
            posOperatorio: this.state.posOperatorioList.filter(x => canBe(x)),
            agendado: this.state.agendadoList.filter(x => canBe(x)),
            ambulatorial: this.state.ambulatorialList.filter(x => canBe(x)),
        })
        this.setState({ loading: false });
    }

    openModal(tipo) {
        let listPacienteFiltredModal = [];
        let modalTitle = ''


        if (tipo == "Finalizado") {
            listPacienteFiltredModal = this.state.finalizado;
            modalTitle = 'Pacientes Atendidos';
        }
        else if (tipo == 'aguardando') {
            // console.log('qtd aguard', this.state.aguardando.length);
            listPacienteFiltredModal = this.state.aguardando;
            modalTitle = 'Pacientes em Análise';

        }
        else if (tipo == 'pedente') {
            listPacienteFiltredModal = this.state.pedente;
            modalTitle = 'Pendências';
        }
        else if (tipo == 'agCirurgia') {
            listPacienteFiltredModal = this.state.agCirurgia;
            modalTitle = 'Aguardando Cirurgia';
        }
        else if (tipo == 'ambulatorial') {
            listPacienteFiltredModal = this.state.ambulatorial;
            modalTitle = 'Acompanhamento Ambulatorial';
        }
        else if (tipo == 'posOperatorio') {
            listPacienteFiltredModal = this.state.posOperatorio;
            modalTitle = 'Acompanhamento Pós-Operatório';
        }
        else if (tipo == 'agendado') {
            listPacienteFiltredModal = this.state.agendado;
            modalTitle = 'Cirurgia Agendada';
        }



        this.setState({
            listPacienteModal: listPacienteFiltredModal,
            modalTitle: modalTitle,
            openModal: true,
            listPacienteModalType: tipo
        }, () => { this.filtrarModal('') });
    }

    filtrarModal(string) {
        let lista = this.state.listPacienteModal;
        if (string && string.trim() != '') {
            lista = this.state.listPacienteModal.filter(x => x && x.paciente
                &&
                (x.paciente.nome.toLowerCase().indexOf(string.toLowerCase()) >= 0
                    ||
                    x.paciente.cpf.toLowerCase().indexOf(string.toLowerCase()) >= 0
                )
            );
        }
        if (lista) {
            this.setState({
                listPacienteFiltredModal: lista.sort((a, b) => { return a.paciente.nome.trim().toUpperCase() < b.paciente.nome.trim().toUpperCase() ? -1 : 1 })
            })
        }
    }

    render() {
        return (
            <React.Fragment>

                <div className="gb-cont-page">
                    <CrudBar
                        title="Consultas Realizadas"
                        breadcrumb={["Globalbrain", "Consultas Realizadas"]}
                    />
                    {this.state.loading && <PreLoaderWidget />}
                    {!this.state.loading && <React.Fragment>
                        <h1 className="gb-sm-hidden"><i className="fa fa-stethoscope" /> Especialidades</h1>
                        <Row>
                            <div className="gb-row-between">
                                <div className="gb-cont-head-panel" id="nav-tab">

                                    <a href="#" className={"gb-head-panel-item " + (this.state.especialidadeSelecionada === '' ? "active" : "")} onClick={() => { this.changeTab(''); }}>Todas</a>
                                    {this.state.especialidades ? this.state.especialidades.map((espec, idx) => {
                                        return (
                                            <>
                                                <a href="#" index={idx} key={idx}
                                                    className={"gb-head-panel-item gb-sm-hidden " + (this.state.especialidadeSelecionada === espec ? "active" : "")}
                                                    onClick={() => { this.changeTab(espec); }}>
                                                    {espec}
                                                </a>
                                                {(this.state.especialidadeSelecionada !== espec) ? ((idx < this.state.especialidades.length - 1) ? <div className="gb-head-divider"></div> : null) : null}
                                            </>
                                        )
                                    }) : null}
                                </div>

                                {(this.state.especialidades.length > 0) ?
                                    <div className="gb-sm-show">
                                        <EspecialidadesDropdown
                                            placeholder="Especialidades"
                                            menuItems={this.state.especialidades}
                                            select={this.state.especialidadeSelecionada}
                                            changeTab={this.changeTab} />
                                    </div> :
                                    null}

                            </div>
                        </Row>
                        <Row className="panel-body-home">
                            {this.state.loading ? (
                                <div className="text-center" style={{
                                    width: '100%', height: '200px', display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <PreLoaderWidget />
                                </div>
                            ) : (<>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Atendidos" valor={this.state.finalizado ? this.state.finalizado.length : 0} action={() => this.openModal('Finalizado')} />
                                </Col>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Análise" valor={this.state.aguardando ? this.state.aguardando.length : 0} action={() => this.openModal('aguardando')} />
                                </Col>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Pendências" valor={this.state.pedente ? this.state.pedente.length : 0} action={() => this.openModal('pedente')} />
                                </Col>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Aguardando Cirurgia" valor={this.state.agCirurgia ? this.state.agCirurgia.length : 0} action={() => this.openModal('agCirurgia')} />
                                </Col>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Acompanhamento Ambulatorial" fontSize={12} valor={this.state.ambulatorial ? this.state.ambulatorial.length : 0} action={() => this.openModal('ambulatorial')} />
                                </Col>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Acompanhamento Pós Operatório" fontSize={12} valor={this.state.posOperatorio ? this.state.posOperatorio.length : 0} action={() => this.openModal('posOperatorio')} />
                                </Col>
                                <Col xs="6" sm="6" lg="3" >
                                    <CardHome descricao="Cirurgia Agendada" valor={this.state.agendado ? this.state.agendado.length : 0} action={() => this.openModal('agendado')} />
                                </Col>
                            </>)}
                        </Row>

                    </React.Fragment>}

                </div>

                <ModalComponent
                    openModal={this.state.openModal}
                    closeModal={() => { this.setState({ openModal: false }) }}
                >
                    {this.state.loading ? (
                        <div className="text-center" style={{
                            width: '100%', height: '200px', display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <PreLoaderWidget />
                        </div>
                    ) : (
                        <>
                            <h3>{this.state.modalTitle}</h3>
                            <input type="text" className="form-control gb-input" placeholder={"Filtrar Nome ou CPF de (" + this.state.listPacienteFiltredModal.length + ") pacientes"} value={this.state.modalFiltro} onChange={(evt) => { this.setState({ modalFiltro: evt.target.value }); }} onKeyUp={(evt) => { this.filtrarModal(evt.target.value) }} />
                            <div className="gb-divider"><div className="line"></div></div>
                            <table className="table table-hover gb-table">
                                <thead>
                                    <tr>
                                        <th>CPF</th>
                                        <th>Nome</th>
                                        <th className="gb-sm-hidden">Cidade</th>
                                        <th className="gb-sm-hidden">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.listPacienteFiltredModal.map((item, index) => {
                                        return (
                                            <tr key={index} onClick={() => {
                                                this.setState({
                                                    openModalPaciente: true,
                                                    modalPacienteID: item.id
                                                });
                                                document.body.classList.add('noOverflow');
                                            }} style={{ cursor: 'pointer' }}>
                                                <td>{item.paciente.cpf}</td>
                                                <td className="gb-table-destaque">{item.paciente.nome}</td>
                                                <td className="gb-sm-hidden">{item.paciente.cidade}</td>
                                                <td className="gb-sm-hidden">{item.paciente.status}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </>
                    )}
                    <ModalComponent
                        full
                        closeStyle={{ fontSize: '30px', margin: '10px' }}
                        openModal={this.state.openModalPaciente}
                        closeModal={() => {
                            if (this.props.onClose) {
                                this.props.onClose();
                            }
                            this.carregar();
                            this.setState({ openModalPaciente: false });
                            document.body.classList.remove('noOverflow');
                        }}
                    >
                        <Paciente
                            id={this.state.modalPacienteID}
                            closeModal={() => { this.carregar(); this.setState({ openModalPaciente: false }) }}
                        />
                    </ModalComponent>
                </ModalComponent>
            </React.Fragment>
        )
    }
}

export default connect()(ConsultasRealizadas);